import { createRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { rootRoute } from './__root';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';
import { PermissionGate } from '@/components/admin/permission-gate';
import { AdminSubNav } from '@/components/admin/admin-sub-nav';
import { DependencyTable } from '@/components/admin/dependency-table';

export const adminObservabilityDependenciesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/admin/observability/dependencies',
  component: AdminObservabilityDependenciesPage,
});

function AdminObservabilityDependenciesPage() {
  return (
    <PermissionGate permission="platform:observe">
      <Dependencies />
    </PermissionGate>
  );
}

function Dependencies() {
  const depsQuery = useQuery({
    queryKey: queryKeys.admin.dependencies(),
    refetchInterval: 5_000,
    queryFn: async () => {
      const { data, error } = await apiClient.GET('/admin/observability/dependencies');
      if (error) throw error;
      return data;
    },
  });

  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-2xl font-semibold">Dependencies</h1>
      <AdminSubNav active="dependencies" />
      {depsQuery.isLoading && (
        <p className="text-sm text-muted-foreground">Loading dependencies…</p>
      )}
      {depsQuery.isError && (
        <p className="text-sm text-red-600">Failed to load dependencies.</p>
      )}
      {depsQuery.data && <DependencyTable dependencies={depsQuery.data.dependencies} />}
    </div>
  );
}
